function storeLocalObject() {
  try {
    localStorage.setItem('_kundportalen_message_cookie', true);
  } catch {
    return false;
  }
  return true;
}

function readLocalObject() {
  let key = false;
  try {
    key = localStorage.getItem('_kundportalen_message_cookie');
  } catch {
    key = false;
  }
  return key === 'true';
}

export { storeLocalObject, readLocalObject };
